export default function log({ next, to }) {
    console.log("1111")
    next();
}